import styled from 'styled-components';
import { themeGet } from 'modules/v2/foundation/theme';
export const ListItemTextContainer = styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;

  gap: ${themeGet('spacing.xs')};
`;
